import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { FormControl } from '@angular/forms';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { PurchaseDetailDTO, PurchaseDetailReadByInvoiceIdForImportRequestDTO } from 'src/app/purchase/purchase/purchase-detail/purchase-detail.interface';
import { PurchaseDetailService } from 'src/app/purchase/purchase/purchase-detail/purchase-detail.service';
import { PurchaseMasterDTO, PurchaseMasterSearchByInvoiceNo } from 'src/app/purchase/purchase/purchase.interface';
import { PurchaseService } from 'src/app/purchase/purchase/purchase.service';



@Component({
  selector: 'app-add-via-purchase-invoice-button',
  templateUrl: './add-via-purchase-invoice-button.component.html',
  styleUrls: ['./add-via-purchase-invoice-button.component.css']
})
export class AddViaPurchaseInvoiceButtonComponent {
  // Emitters 
  @Input() EnablePriceEdit: boolean = false
  @Input({ required: true }) MasterId: number = 0
  @Input({ required: true }) MasterType: string = ''
  @Output() onSubmit: EventEmitter<PurchaseDetailDTO[]> = new EventEmitter<PurchaseDetailDTO[]>();


  // flags
  isSubmitting: boolean = false
  PurchaseNo = new FormControl('')
  title = 'Purchase Invoice'
  dataLoading: boolean = false

  // services
  modalService = inject(NgbModal)
  User = inject(UserLoginService).User();
  PurchaseService = inject(PurchaseService)
  PurchaseDetailService = inject(PurchaseDetailService)

  //Items
  purchaseInvoiceList: PurchaseMasterDTO[] = [];   // search results
  SelectedPurchaseItems: PurchaseDetailDTO[] = []; // table
  SelectedDetailItems: PurchaseDetailDTO[] = [];


  // modal ref 
  purchaseModalRef!: NgbModalRef
  @ViewChild('PurchaseItemModal', { static: true }) PurchaseModalTemplate!: ElementRef


  changeAllQty(event: any) {
    const value = Number(event.target.value);
    this.SelectedPurchaseItems.forEach(i => i.qty = value);
  }

  changeAllPrice(event: any) {
    const value = Number(event.target.value);
    this.SelectedPurchaseItems.filter(i => i.isSelected).forEach(i => i.price = value);
  }


  ngOnInit() {
    this.PurchaseNo.valueChanges.subscribe(res => {
      if (res) {
        this.GetItemsByPurchaseInvoiceId(Number(res));
      }
    });


  }

  searchLoading: boolean = false;
  openModal() {
    this.PurchaseNo.reset();
    this.purchaseInvoiceList = [];
    this.SelectedDetailItems = [];
    this.SelectedPurchaseItems = [];
    this.searchLoading = true;
    let data: PurchaseMasterSearchByInvoiceNo = {
      invoiceNo: '',
      tenantId: Number(this.User.companyId),
      tenantBranchId: this.User.loggedInBranchId,
    }
    this.PurchaseService.PurchaseMaster_SearchByInvoiceNo(data).subscribe(res => {
      this.purchaseInvoiceList = res.items;
      this.searchLoading = false;
    });
    this.purchaseModalRef = this.modalService.open(this.PurchaseModalTemplate, { size: 'lg', backdrop: 'static' });
  }

  GetItemsByPurchaseInvoiceId(invoiceId: number) {
    this.dataLoading = true
    // Switching invoice: drop ticks from the previous one so they aren't imported with this one
    this.SelectedDetailItems = [];

    const payload: PurchaseDetailReadByInvoiceIdForImportRequestDTO = {
      invoiceId: invoiceId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      masterType: this.MasterType,
      masterId: this.MasterId
    }

    this.PurchaseDetailService.PurchaseDetail_ReadByInvoiceIdForImport(payload).subscribe(res => {
      this.SelectedPurchaseItems = res.items,

        this.SelectedPurchaseItems.forEach(item => {
          // Use availableQty if the SP computed it (> 0), otherwise fall back to the raw qty from the invoice.
          // availableQty may be 0 when the SP hasn't implemented utilization tracking for the target masterType yet.
          const available = parseFloat(item.availableQty as any);
          item.qty = available > 0 ? available : (item.qty || 0);
        });

      this.dataLoading = false

    })
  }

  submitResults() {
    this.isSubmitting = true
    this.onSubmit.emit(this.SelectedDetailItems)

  }

  onSelctionCheckboxChange(event: any, item: PurchaseDetailDTO) {
    item.isSelected = event.target.checked;
    let isDuplicate = this.SelectedDetailItems.find(i => i.detailId == item.detailId);

    if (event.target.checked) {
      if (!isDuplicate) this.SelectedDetailItems.push(item);
    } else {
      this.SelectedDetailItems = this.SelectedDetailItems.filter(i => i.detailId != item.detailId);
    }
    console.log(this.SelectedDetailItems);
  }

  onSelectAllCheckboxChange(event: any) {
    if (event.target.checked) {
      // Clear previous selections
      this.SelectedDetailItems = [];

      this.SelectedPurchaseItems.forEach(i => i.isSelected = true);
      this.SelectedDetailItems = [...this.SelectedPurchaseItems];
    } else {
      this.SelectedPurchaseItems.forEach(i => i.isSelected = false);
      this.SelectedDetailItems = [];
    }
    console.log(this.SelectedDetailItems);
  }


  // Search 
  SearchPurchaseInvoice(event: { term: string; items: any[]; }) {
    console.log(event.term);
    setTimeout(() => {
      this.searchLoading = true;

      let data: PurchaseMasterSearchByInvoiceNo = {
        invoiceNo: event.term,
        tenantId: Number(this.User.companyId),
        tenantBranchId: this.User.loggedInBranchId,
      }
      this.PurchaseService.PurchaseMaster_SearchByInvoiceNo(data).subscribe(res => {
        this.purchaseInvoiceList = res.items;
        this.searchLoading = false;

      });

    }, 500);
  }

}


